import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { ElementsAnalyze } from '@src/slide/domain/ui-model/element-modeles/elements-analysis';

/**
 * 获取Model集合中所有的图表渲染状态
 */
export function getChartsRenderStatusInSlide(slideModel: ISlideModel): Promise<any>[] {
    const chartModelList = ElementsAnalyze.getTypesOfElements(slideModel.children, [UIModelType.CHART]);

    return chartModelList.map((model: any) => model.syncRenderStatus as Promise<any>);
}
